<template>
    <section>
        <header class="mt-6 mb-0">
            <h1 class="fs-32 m-0 regular">{{ $l10n.__('Configurez votre renouvellement d’abonnement') }}</h1>
        </header>
        <recurrency-toggle store="renew"></recurrency-toggle>
        <article>
            <header class="flex-level mt-6 mb-5 pb-1">
                <h2 class="m-0">{{ $l10n.__('Ajouter des licences')}}</h2>
            </header>
            <el-form-item prop="products" class="mb-2">
                <licence-product
                    class="mb-5"
                    v-for="product in availablesProducts" :key="product.code"
                    :value="products[product.id]"
                    :product="product" 
                    :plan="plan"
                    userType="client"
                    :numformat="numformat"
                    @input="updateProductQuantity">
                </licence-product>
            </el-form-item>    
        </article>

        <div class="separator gray-05-bkg"></div>
        <!-- Extras Modules -->
        <article>
            <el-form-item>
                <header>
                    <h2 class="mb-5 mt-6">{{ $l10n.__('Modules supplémentaires') }}</h2>
                </header>
                <bonus-pack
                    class="mb-5"
                    v-for="product in bonusPacksClient" :key="product.code"
                    :value="products[product.id]"
                    :product="product" 
                    :plan="plan"
                    userType="client"
                    :numformat="numformat"
                    :sourceLimitation="isSourceSale"
                    context="renew"
                    @input="updateProductQuantity"
                    @changePackPlan="switchPackPlan"
                >
                </bonus-pack>
            </el-form-item>
        </article>
    </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import LicenceProduct from 'vcomponents/pages/account/LicenceProduct.vue';
import RecurrencyToggle from 'vcomponents/pages/account/client/RecurrencyToggle.vue';
import BonusPack from 'vcomponents/pages/account/BonusPack.vue';

const renewCart = createNamespacedHelpers('renewCart');
export default {
    computed: {
        ...renewCart.mapGetters([
            'availablesProducts',
            'products',
            'plan',
            'numformat',
            'bonusPacksClient',
            'isSourceSale',
        ]),
    },
    methods: {
        ...renewCart.mapActions([
            'updateProductQuantity',
            'switchPackPlan'
        ]),
    },
    components: {
        LicenceProduct,
        RecurrencyToggle,
        BonusPack,
    }
}
</script>
